export default {"src":"/_next/static/media/our-partners-img-one.3a090a3d.svg","height":88,"width":248};